import { Routes } from '@angular/router';
import { pageGuard } from './core/gaurd/guards/page.guard';
import { PmrPoliciesComponent } from './features/pick-me-right/pmr-policies/pmr-policies.component';

export const routes: Routes = [  
  // {
  //   path: '',
  //   redirectTo: 'customer',
  //   pathMatch: 'full'
  // },
   {
    path: '',
    loadComponent: () =>
      import('./features/pick-me-right/pick-me-right.component')
      .then(m => m.PickMeRightComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path:'signup',
    loadComponent: () => import('./features/auth/signup/signup.component').then(m => m.SignupComponent)
  },
  {
    path: 'customer',
    canActivate: [pageGuard],
    data: { role: 'customer' },
    loadChildren: () => import('./features/customer/customer.routes').then(m => m.customerRoutes)
  },
  {
    path: 'admin',
    canActivate: [pageGuard],
    data: { role: 'admin' },
    loadChildren: () => import('./features/admin/admin.routes').then(m => m.adminRoutes)
  },
  {
    path: 'vendor',
    canActivate: [pageGuard],
    data: { role: 'vendor' },
    loadChildren: () => import('./features/vendor/vendor.routes').then(m => m.vendorRoutes)
  },
  { path: 'maintenance', 
    canActivate: [pageGuard],
    data: { role: 'admin' },
    loadComponent: () => import('./features/maintenance-hub/maintenance-hub.component').then(m => m.MaintenanceHubComponent) 
  },
  { path: 'policies', component: PmrPoliciesComponent },
  { path: 'policies/:id', component: PmrPoliciesComponent },
];
 